import store from '../store'

const collectPerms = (menus, set) => {
  if (!Array.isArray(menus)) return
  menus.forEach(menu => {
    if (menu && menu.perms) {
      set.add(menu.perms)
    }
    if (menu && Array.isArray(menu.children) && menu.children.length > 0) {
      collectPerms(menu.children, set)
    }
  })
}

const hasPermission = perms => {
  const required = Array.isArray(perms) ? perms : [perms]
  const menus = store.getters['user/menus'] || store.state.user.menus || []
  const permSet = new Set()
  collectPerms(menus, permSet)
  return required.some(item => permSet.has(item))
}

const hasPermi = {
  inserted(el, binding) {
    const { value } = binding
    if (!value || (Array.isArray(value) && value.length === 0)) {
      throw new Error('v-hasPermi 需要配置权限标识数组或字符串')
    }
    if (!hasPermission(value)) {
      if (el.parentNode) {
        el.parentNode.removeChild(el)
      }
    }
  }
}

export default hasPermi
